export default __webpack_public_path__ + "static/media/thumbnail.3920ca83.png";